<template>
	<div class="no-page">
	  <SubTopNav title="Page not Found" />
	  <div class="no-page-grid">
		  <div class="numbers">404</div>
		  <h3>Sorry, we can't find the page you're looking for</h3>
		  <router-link to="/"><h4>Home Page &raquo;</h4></router-link>
	  </div>
  </div>
</template>
<script>
// @ is an alias to /src
	import SubTopNav from "@/components/SubTopNav.vue";


	export default {
	  name: "about",
	  components: {
	    SubTopNav
	  },
	};
</script>
<style scoped>
	.numbers{
		font-size:300pt;
		line-height:300pt;
	}

	.no-page{
		text-align:left;
		padding:0 350px 100px 5%;
	}

	.no-page-grid{
		display:grid;
		grid-template-columns: 1fr 1fr;
		grid-gap:25px;
	}

	@media (max-width: 1024px){
		.numbers{
			font-size:200pt;
			line-height:200pt;
		}

		.no-page{
			text-align:left;
			padding:0 350px 100px 5%;
		}

		.no-page-grid{
			display:grid;
			grid-template-columns: 1fr;
			grid-gap:25px;
		}
	}



</style>
